module.exports = __webpack_public_path__ + "img/shoulder.7c070371.png";